import type { UiLanguage } from '../../i18n/uiLanguage';

const LEGAL_SITE = 'https://site.notreu.com';

/** 表示言語の公開ページ。本文があるのは /ja/ と /en/。言語なしの /terms/ は本文が無い。 */
export function paidLegalPageUrls(language: UiLanguage): {
  terms: string;
  privacy: string;
  tokusho: string;
} {
  const lang = language === 'ja' ? 'ja' : 'en';
  return {
    terms: `${LEGAL_SITE}/${lang}/terms/`,
    privacy: `${LEGAL_SITE}/${lang}/privacy/`,
    tokusho: `${LEGAL_SITE}/${lang}/tokushoho/`,
  };
}

/** 規約を改定したらここを更新する（同意記録に保存される） */
export const PAID_TERMS_VERSION = '2026-10-27';
